// extracted by mini-css-extract-plugin
module.exports = {"root":"UserNav_root__2CHiI","tab":"UserNav_tab__1F8m5"};